import React from 'react'
import './style/index.css'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Autoplay, Pagination } from 'swiper'
import image from '../../assets/item-center.png'
export default function Carousels() {
  //轮播图内容
  const [carousel] = useState({
    carouselItem: [
      {
        img: require('../../assets/GL8.jpg'),
        tetx: 'GL8不香了！全新东风本田艾力绅上市 新增“黑爵士”外观 售价27.98万起',
        name: '快车志',
        iocn: require('../../assets/item-center.png'),
        like: 34,
        dislike: 63,
      },
      {
        img: require('../../assets/P70.jpg'),
        tetx: '华为P70Pro另辟蹊径：7100毫安+7.1英寸，万元以内最强旗舰',
        name: '以优料',
        iocn: require('../../assets/item-center.png'),
        like: 5,
        dislike: 9,
      },
      {
        img: require('../../assets/iPhone15.jpg'),
        tetx: '福伦达推出NOKTON 35mm F0.9 Aspherical X卡口镜头，22.5 万日元',
        name: '中关村',
        iocn: require('../../assets/item-center.png'),
        like: 34,
        dislike: 63,
      },
    ],
  })
  return (
    <div className=" center-item item1">
      <div className="asd">
        <Swiper
          className="swiper"
          spaceBetween={50}
          modules={[Autoplay, Navigation, Pagination]}
          autoplay={{ delay: 2000 }}
          navigation
          loop
          pagination={{ clickable: true }}>
          {carousel.carouselItem.map((item, index) => (
            <SwiperSlide key={index}>
              <img className="image" src={item.img} alt="" />
              <div className="name">
                <img src={image} alt="" />
                {item.name} <div className="text">{item.tetx}</div>
                <div className="like">
                  <i className="iconfont icon-dianzan"></i>
                  <span>{item.like}</span>
                  <i className="iconfont icon-buxihuan"></i>
                  <span>{item.dislike}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="swiper-pagination"></div>
        </Swiper>
      </div>
    </div>
  )
}
